import { useContext, useState } from 'react';
import FieldContext from '../../FieldContext';
import CollapsibleActionMenu from '@/components/CollapsibleActionMenu';
import { ListItemIcon } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import ModelsContext from '../../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import { type EditorFieldWithoutRelations } from '@/lib/types';
import SelectedModelIdContext from '../../../../../SelectedModelIdContext';

const ClearFieldName = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { field } = useContext(FieldContext);

  const [saving, setSaving] = useState(false);

  const clearName = async (): Promise<void> => {
    setSaving(true);

    const updatedField = await api.delete<EditorFieldWithoutRelations>(
      `editor/challenge-model/fields/${field!.id}/name`,
    );

    setModels(models => {
      models[selectedModelId].fields[field!.id] = {
        ...models[selectedModelId].fields[field!.id],
        ...updatedField,
      };
    });

    setSaving(false);
  };

  const nameAlreadyCleared = !field!.name || field!.name.trim() === '';

  return (
    <CollapsibleActionMenu.Button
      onClick={clearName}
      disabled={nameAlreadyCleared || saving}
    >
      <ListItemIcon>
        <ClearIcon />
      </ListItemIcon>
      <FormattedMessage id="editor.model_editor.actions.clear_name" />
    </CollapsibleActionMenu.Button>
  );
};

export default ClearFieldName;
